import type { JSX } from 'react';
import curationsBlocker from '@/assets/images/curationsBlocker.webp';
import styles from './CurationInstallSheet.module.css';

// 1. Update Interface to accept deepLink
interface CurationInstallSheetProps {
  onOpenApp: () => void;
}

const CurationInstallSheet = ({
  onOpenApp,
}: CurationInstallSheetProps): JSX.Element => {
  return (
    <>
      <div className={styles.overlay} />
      <div className={styles.sheet}>
        <div className={styles.content}>
          <img
            src={curationsBlocker}
            alt="Download Slayd App"
            className={styles.image}
          />
          <button className={styles.downloadButton} onClick={onOpenApp}>
            Open in App
          </button>
        </div>
      </div>
    </>
  );
};

export default CurationInstallSheet;
